module.exports = __webpack_public_path__ + "img/fn-goal-6.d687301b.jpg";